
<template>
   <div
      :class="isMobile ? 'isMobile' : ''"
      class="cta-card-anfitriao p-card rounded shadow-sm m-auto"
   >
      <h2 class="h4 text-white">Seja Anfitrião de Bikes</h2>
      <el-button
         type="secondary"
         class="font-weight-bold mt-1 mb-2"
         size="medium"
         @click="goToBlog"
      >
         Saiba mais
      </el-button>
   </div>
</template>

<script>
export default {
   name: 'CtaAnfitriao',
   props: {
      isMobile: {
         type: Boolean,
         default: false
      }
   },
   mounted() {

   },
   data() {
      return {

      }
   },
   methods: {
      goToBlog() {
         window.location.href = 'https://pedale.net.br/blog/2023/09/26/anfitriao-de-bicicleta/'
      },
   },
   computed: {

   }
}
</script>

<style scoped>
   .isMobile {
      background-color: #4ab555 !important;
      border-radius: 20px !important;
      margin-top: 16px !important;
   }
</style>
